/**
 * Browser Sentry for the Shopify storefront.
 * Initializes as soon as the SDK script has loaded.
 * Transaction names use the Shopify template (e.g. product, collection)
 * or the page URL handle (e.g. page.black-friday) so vitals group by page.
 */
(function () {
  if (!window.Sentry || window.__samduoSentryInited) return;
  window.__samduoSentryInited = true;

  var host = window.location.hostname;
  var local = host === "127.0.0.1" || host === "localhost";
  var page = window.__samduoSentryPage || {};

  function pageHandleFromPath(pathname) {
    var match = (pathname || "").match(/^\/pages\/([^/]+)\/?$/);
    return match ? match[1] : "";
  }

  function nameFromPath(pathname) {
    var path = (pathname || "/").replace(/\/+$/, "") || "/";
    var pageHandle = pageHandleFromPath(path);
    if (path === "/") return "index";
    if (path === "/cart") return "cart";
    if (path === "/search") return "search";
    if (path === "/collections") return "list-collections";
    if (/^\/products\/[^/]+$/.test(path)) return "product";
    if (/^\/collections\/[^/]+$/.test(path)) return "collection";
    if (/^\/collections\/[^/]+\/products\/[^/]+$/.test(path)) return "product";
    if (pageHandle) return "page." + pageHandle;
    if (/^\/blogs\/[^/]+$/.test(path)) return "blog";
    if (/^\/blogs\/[^/]+\/[^/]+$/.test(path)) return "article";
    if (/^\/account(\/|$)/.test(path)) return "customers";
    if (/^\/challenge/.test(path)) return "challenge";
    if (/^\/discount\//.test(path)) return "discount";
    return "other";
  }

  function transactionName(pathname) {
    if (page.pageType === "page") {
      var handle = page.handle || pageHandleFromPath(pathname);
      return handle ? "page." + handle : "page";
    }
    if (page.template) {
      return page.suffix ? page.template + "." + page.suffix : page.template;
    }
    return nameFromPath(pathname);
  }

  var initialName = transactionName(window.location.pathname);

  Sentry.init({
    dsn: "https://65a039987b7981348f1da20f27b7cc1c@o4512287114133504.ingest.de.sentry.io/4512287147229264",
    release: "samduo-shopify@1.0.0",
    environment: local ? "development" : "production",
    integrations: [
      Sentry.browserTracingIntegration({
        beforeStartSpan: function (context) {
          if (context.op !== "pageload" && context.op !== "navigation") {
            return context;
          }
          // Navigations only rewrite the query string (?variant=, filters) or
          // restore from bfcache, so they stay on the initial page.
          return Object.assign({}, context, { name: initialName });
        },
      }),
    ],
    tracesSampleRate: local ? 1.0 : 0.5,
    tracePropagationTargets: [
      "localhost",
      "127.0.0.1",
      /^https:\/\/([a-z0-9-]+\.)*samduo\.(com|de|nl)/,
    ],
  });

  if (page.pageType) Sentry.setTag("page_type", page.pageType);
  if (initialName) Sentry.setTag("template", initialName);
  if (page.locale) Sentry.setTag("locale", page.locale);
})();
